import React from "react";
import SEO from "../../../components/SEO";
import { Mail, Award } from "lucide-react";
import GurkiranImg from "../../../assets/Gurkiran.jpg";
import Testimonials from "../../../components/Testimonials";

const Gurkiran = () => {

  const facts = [
    {
      title: "Études",
      backText:
        "Les réalisations scolaires de Gurkiran témoignent de son engagement envers l'excellence. Elle a complété ses études secondaires à Sirhind, où elle a été reconnue pour ses performances exceptionnelles. Elle a ensuite poursuivi des études supérieures au Canada à l'Institut Conestoga, où elle a obtenu un diplôme en marketing commercial et commerce électronique. Son engagement à développer ses compétences se manifeste par son expertise en design UX et en campagnes publicitaires ciblées.",
    },
    {
      title: "Carrière",
      backText:
        "Gurkiran a débuté son parcours professionnel dans le marketing canadien en 2021, s'établissant rapidement grâce à son approche innovante et sa vision stratégique. En faisant la transition vers le secteur de l'assurance vie, elle a rejoint einsured.ca en tant que conseillère en sécurité financière, où elle a un impact significatif depuis plus d'un an. Reconnue pour son ambition et son ardeur au travail, Gurkiran s'engage à aider ses clients à atteindre leurs objectifs financiers tout en continuant à progresser dans son rôle.",
    },
    {
      title: "Jeunesse",
      backText:
        "Gurkiran Kaur est une professionnelle dévouée et dynamique basée au Canada, connue pour son ambition et sa nature travailleuse. Originaire de Sirhind où elle a excellé académiquement et s'est démarquée tout au long de ses années de lycée. Gurkiran s'est parfaitement intégrée dans le paysage professionnel canadien, faisant des progrès significatifs dans son domaine. Ses années de formation ont été marquées par la dévotion et la passion de l'apprentissage, posant des bases solides pour ses futures réalisations.",
    },
    {
      title: "Loisirs",
      icon: <Award size={36} />,
      backText:
        "Dans ses moments de loisirs, Gurkiran exprime sa créativité à travers le design, la lecture et la création d'art en résine. Ces loisirs lui apportent non seulement détente et joie, mais lui permettent aussi d'exprimer ses talents artistiques et de se détendre de sa vie professionnelle bien remplie. Sa passion pour le design et la créativité ajoute une dimension unique à ses aspirations personnelles et professionnelles.",
    },
  ];

  return (
    <>
      <SEO
        title="Gurkiran — Courtière d'assurance - einsured.ca"
        description="Découvrez Gurkiran, courtière expérimentée chez einsured.ca. Profitez de conseils fiables et de solutions personnalisées. Contactez-la dès aujourd’hui !"
        keywords="Gurkiran courtière d'assurance, conseillère en assurance Canada, meilleur courtier d'assurance, expert en assurance vie"
        ogType="profile"
      />
      <section
        className="min-h-screen flex flex-col justify-center items-center px-6 sm:px-12 md:px-24 py-16"
        style={{ backgroundColor: "#f5f9ff" }}
      >
        <style>{`
          .flip-card {
            background-color: transparent;
            perspective: 1000px;
          }
          .flip-card-inner {
            position: relative;
            width: 100%;
            height: 260px;
            text-align: center;
            transition: transform 0.8s;
            transform-style: preserve-3d;
            border-radius: 24px;
            box-shadow: 0 15px 25px rgba(0, 0, 0, 0.15);
          }
          .flip-card:hover .flip-card-inner {
            transform: rotateY(180deg);
          }
          .flip-card-front,
          .flip-card-back {
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 24px;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-family: "Montserrat", sans-serif;
            font-weight: 600;
          }
          .flip-card-front {
            background: linear-gradient(to bottom, #12a5dd, #3b4f80);
            color: white;
          }
          .flip-card-back {
            background: linear-gradient(to bottom, #3b4f80, #12a5dd);
            transform: rotateY(180deg);
            color: white;
            padding: 0 1.5rem;
          }

          /* Mobile polish for flip cards */
          @media (max-width: 640px) {
            .flip-card-inner {
              height: auto;
              min-height: 260px;
              transform: none !important;
            }
            .flip-card-front {
              display: none;
            }
            .flip-card-back {
              transform: none;
              padding: 1.25rem 1.25rem;
            }
          }
        `}</style>

        {/* TOP SECTION */}
        <div className="max-w-6xl w-full grid md:grid-cols-2 gap-12 items-start">
          {/* LEFT SIDE */}
          <div className="flex flex-col items-center md:items-start w-full">
            {/* Blue Box */}
            <div
              className="w-full rounded-t-[32px] px-8 py-6 text-center md:text-left shadow-md"
              style={{ backgroundColor: "#12a5dd", color: "white" }}
            >
              <h1 className="text-3xl sm:text-4xl font-bold mb-2">
                Gurkiran Kaur
              </h1>
              <p className="text-lg font-semibold">Courtière d'assurance</p>
            </div>

            {/* Bottom Blue Box */}
            <div
              className="w-full rounded-b-[32px] px-8 py-8 shadow-lg"
              style={{ backgroundColor: "#12a5dd", color: "white" }}
            >
              <p className="text-sm sm:text-base leading-relaxed mb-10 text-center md:text-left">
                Gurkiran Kaur est une courtière d'assurance très accomplie chez
                einsured.ca, ayant fait la transition d'une carrière réussie dans
                le marketing canadien vers le secteur de l'assurance vie. Depuis son entrée
                dans le domaine de l'assurance vie, ses stratégies innovantes ont
                considérablement amplifié son impact au sein de l'industrie.
              </p>

              {/* CONTACT */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
                <a
                  href="tel:+14168400128"
                  className="bg-white text-[#3b5180] font-medium text-base px-6 py-3 rounded-full shadow-md text-center"
                >
                  (416) 840-0128 ext. 103
                </a>

                <a
                  href="mailto:gurkiran@einsured.ca"
                  className="bg-white text-[#3b5180] font-medium text-base px-6 py-3 rounded-full shadow-md flex items-center justify-center gap-2 break-all sm:break-normal"
                >
                  <Mail className="w-4 h-4" />
                  gurkiran@einsured.ca
                </a>
              </div>
            </div>

            {/* Call Now */}
            <div className="text-center md:text-left mt-10 md:mt-12 w-full">
            <a
              href="https://book.einsured.ca/widget/bookings/ei-team"
              className="bg-[#3b4f80] hover:bg-[#2f3d66] text-white font-semibold px-10 py-3 rounded-full shadow-md transition w-full sm:w-auto inline-block text-center"
            >
              Prendre rendez-vous
            </a>
              <p className="text-sm mt-6">Consultations gratuites de 15 à 30 minutes.</p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="flex justify-center md:justify-end mt-8 md:mt-0">
            <img
              src={GurkiranImg}
              alt="Gurkiran Kaur"
              className="rounded-[32px] shadow-md w-full max-w-xs sm:max-w-sm h-[420px] object-cover object-top"
            />
          </div>
        </div>

        {/* FACTS */}
        <div className="mt-24 max-w-6xl w-full">
          <div className="text-center mb-12 px-2">
            <h2 className="text-3xl sm:text-5xl font-bold text-[#49628b] mb-4">
              Quelques faits sur Gurkiran Kaur
            </h2>
            <p className=" text-base sm:text-lg">
              Découvrez le profil de Gurkiran pour mieux connaître ses domaines d'expertise et ses intérêts personnels.
            </p>
          </div>

          {/* Flip Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 max-w-5xl mx-auto">
            {facts.map((fact) => (
              <div key={fact.title} className="flip-card">
                <div className="flip-card-inner">
                  {/* FRONT */}
                  <div className="flip-card-front px-4">
                    {fact.icon && (
                      <div className="mb-3 flex justify-center">
                        {fact.icon}
                      </div>
                    )}
                    <h3 className="text-white text-2xl font-bold">
                      {fact.title}
                    </h3>
                  </div>

                  {/* BACK */}
                  <div className="flip-card-back flex px-4">
                    <p className="text-white text-sm sm:text-base leading-relaxed font-normal">
                      {fact.backText}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4 EASY STEPS */}
      <section className="w-full flex justify-center bg-white py-16 sm:py-24 px-6 sm:px-12 md:px-24">
        <div className="max-w-6xl w-full grid md:grid-cols-2 gap-16 items-center">
          {/* LEFT SIDE TEXT */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left">
            <h2 className="text-3xl sm:text-5xl font-bold text-[#49628b] mb-5">
              4 étapes simples
            </h2>
            <p className="text-base sm:text-lg text-[#5f6f8f] mb-10 max-w-lg">
              Obtenez votre protection en quelques minutes et profitez d'une couverture d'assurance vie
              parfaitement adaptée à vos besoins.
            </p>

            <a
              href="tel:+14168400128"
              className="bg-[#3b4f80] hover:bg-[#2f3d66] text-white font-semibold px-12 py-3.5 rounded-full shadow-lg transition w-full sm:w-auto text-center"
            >
              Appelez maintenant !
            </a>
            <p className="text-sm mt-4">Consultations gratuites de 15 à 30 minutes.</p>
          </div>

          {/* RIGHT SIDE */}
          <div className="bg-[#f5f8ff] rounded-[32px] shadow-lg px-6 sm:px-10 py-8 sm:py-10 md:px-14 md:py-12">
            <div className="relative pl-2 sm:pl-4">
              <div className="absolute left-6 sm:left-8 top-6 bottom-6 w-[2px] bg-[#3b4f80]/25"></div>

              {/* Step 1 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">
                  1
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">
                    Informations de base
                  </h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">
                    Répondez à quelques questions de base pour nous aider à mieux vous connaître.
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">
                  2
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">
                    Analyse des besoins
                  </h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">
                    Déterminez la couverture appropriée pour protéger vos proches.
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-4 sm:gap-6 mb-8 sm:mb-10 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">
                  3
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">
                    Questions de santé
                  </h3>
                  <p className="text-[#5f6f8f] text-sm md:text-base leading-relaxed">
                    Répondez à quelques questions liées à la santé pour obtenir un produit adapté à vos besoins.
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-start gap-4 sm:gap-6 relative z-10">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#12a5dd] text-white rounded-full font-semibold text-lg sm:text-xl shrink-0">
                  4
                </div>
                <div>
                  <h3 className="text-[#49628b] font-bold text-base sm:text-lg mb-1">
                    Obtenez votre devis gratuit !
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default Gurkiran;
